import { render, staticRenderFns } from "./YzhConnection.vue?vue&type=template&id=65d84bf0&scoped=true"
import script from "./YzhConnection.vue?vue&type=script&lang=js"
export * from "./YzhConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d84bf0",
  null
  
)

export default component.exports